import {Container} from 'inversify';

import {API_BASE_URL} from '../../../config/api';

import {store} from '../../../state/store';

import entityModule from '../../evidences/container/config-module';
import timelineModule from '../../timeline/container/config-module';
// import fakeConfig from '../../fakes/config-module';
import RequestService, {IRequestService} from '../request-service';
import keys from './keys';

export const container = new Container();

// the node environment variable NODE_ENV is bound to process.env.NODE_ENV at build time
container.bind<string>(keys.NODE_ENV).toConstantValue(process.env.NODE_ENV || 'development');

container.bind<string>(keys.BASE_URL).toConstantValue(API_BASE_URL);

container.bind(keys.store).toConstantValue(store);

container.bind<IRequestService>(keys.IRequestService).to(RequestService).inSingletonScope();

container.load(entityModule);
container.load(timelineModule);
